/**
 * Complementary / app recommendations: imperative init.
 * Uses Product Recommendations + Section Rendering API (Shopify).
 *
 * Debug: filter console by [boom-comp]. Silence with window.__BOOM_COMP_DEBUG = false
 * Manual state: window.__boomCompDumpState()
 */
(function () {
  function compLog() {
    if (window.__BOOM_COMP_DEBUG === false) return;
    var a = ['[boom-comp]'].concat(Array.prototype.slice.call(arguments));
    console.info.apply(console, a);
  }

  compLog('asset executing (IIFE start)', {
    readyState: document.readyState,
    href: window.location && window.location.href,
  });

  window.__BOOM_COMP_REC_QUEUE = window.__BOOM_COMP_REC_QUEUE || [];

  var SELECTOR = '[data-complementary-product]';
  var bootCount = 0;
  var warnedNoComplementaryMarkup = false;

  window.__boomCompDumpState = function () {
    var nodes = document.querySelectorAll(SELECTOR);
    var out = {
      queue: window.__BOOM_COMP_REC_QUEUE ? window.__BOOM_COMP_REC_QUEUE.slice() : null,
      nodeCount: nodes.length,
      nodes: [],
    };
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      out.nodes.push({
        id: n.id,
        hasDataUrl: !!(n.getAttribute('data-url') || '').trim(),
        dataUrlPreview: (n.getAttribute('data-url') || '').slice(0, 120),
        initialized: n.getAttribute('data-comp-initialized'),
        childProductCount: n.querySelectorAll('.product').length,
      });
    }
    compLog('__boomCompDumpState()', out);
    return out;
  };

  function normalizeRecommendationsUrl(url) {
    if (!url) return url;
    try {
      return new URL(url, window.location.href).href;
    } catch (e) {
      var root =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
        (window.routes && window.routes.root) ||
        '';
      if (url.indexOf('http') === 0) return url;
      return root + (url.charAt(0) === '/' ? url : '/' + url);
    }
  }

  function findComplementaryFragment(doc, elementId) {
    var el = elementId ? doc.getElementById(elementId) : null;
    if (el) return el;
    el = doc.querySelector(SELECTOR);
    if (el) return el;
    var wrappers = doc.querySelectorAll('[id^="shopify-section-"]');
    for (var i = 0; i < wrappers.length; i++) {
      var w = wrappers[i];
      if (elementId) {
        try {
          var byId = w.querySelector('[id="' + elementId.replace(/"/g, '\\"') + '"]');
          if (byId) return byId;
        } catch (e2) {
          /* ignore */
        }
      }
      var inner = w.querySelector(SELECTOR);
      if (inner) return inner;
    }
    return null;
  }

  function whenJQuerySlickReady(fn) {
    var maxAttempts = 200;
    var attempts = 0;
    function tick() {
      var $ = window.jQuery || window.$;
      if ($ && $.fn && typeof $.fn.slick === 'function') {
        compLog('jQuery + Slick ready after ticks=', attempts);
        fn($);
        return;
      }
      attempts += 1;
      if (attempts < maxAttempts) {
        requestAnimationFrame(tick);
      } else {
        compLog('WARN: jQuery/Slick never became ready; ticks=', attempts);
      }
    }
    tick();
  }

  function ensureArrows() {
    if (!window.arrows) {
      window.arrows = {
        icon_next: '<button type="button" class="slick-next" aria-label="Next">›</button>',
        icon_prev: '<button type="button" class="slick-prev" aria-label="Previous">‹</button>',
      };
    }
  }

  function calculateCard06Padding(container) {
    if (!document.body.classList.contains('product-card-layout-06')) return;
    var actionEl = container.querySelector('.product .card-action');
    var slickList = container.querySelector('.slick-list');
    if (!actionEl || !slickList) return;
    slickList.style.paddingBottom = actionEl.scrollHeight + 'px';
  }

  function initializeSlider(container, $) {
    var productCarousel =
      container.querySelector('.products-carousel') || container.querySelector('.products-carousel-1');
    if (!productCarousel) {
      compLog('initializeSlider: no .products-carousel found on container id=', container.id);
      return;
    }

    ensureArrows();

    var itemArrows = productCarousel.dataset.itemArrows === 'true';
    var itemDots = productCarousel.dataset.itemDots === 'true';
    var itemRows = parseInt(productCarousel.dataset.itemRows, 10);
    var itemToShow = parseInt(productCarousel.dataset.itemToShow, 10);
    var complementaryStyle = container.classList.contains('style-1');

    $(productCarousel).on('init', function () {
      calculateCard06Padding(container);
    });

    if (!productCarousel.classList.contains('slick-slider')) {
      $(productCarousel).slick({
        dots: itemDots,
        arrows: itemArrows,
        slidesToShow: complementaryStyle ? itemToShow : 1,
        rows: !complementaryStyle ? itemRows : 1,
        slidesToScroll: 1,
        slidesPerRow: 1,
        infinite: false,
        rtl: window.rtl_slick,
        nextArrow: window.arrows.icon_next,
        prevArrow: window.arrows.icon_prev,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              get slidesToShow() {
                if (complementaryStyle) {
                  return (this.slidesToShow = 2);
                }
                return (this.slidesToShow = 1);
              },
            },
          },
          {
            breakpoint: 992,
            settings: {
              get slidesToShow() {
                if (complementaryStyle) {
                  return (this.slidesToShow = 2);
                }
                return (this.slidesToShow = 1);
              },
            },
          },
          {
            breakpoint: 768,
            settings: {
              get slidesToShow() {
                if (complementaryStyle) {
                  return (this.slidesToShow = 2);
                }
                return (this.slidesToShow = 1);
              },
            },
          },
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
      compLog('Slick initialized on container id=', container.id);
    }
  }

  function fetchProducts(container, requestUrl, isRetry) {
    compLog('fetchProducts CALLED', {
      containerId: container && container.id,
      isRetry: !!isRetry,
      urlPreview: (requestUrl || '').slice(0, 160),
    });

    var resolvedUrl = normalizeRecommendationsUrl(requestUrl);
    compLog('fetch GET', resolvedUrl);

    fetch(resolvedUrl, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    })
      .then(function (res) {
        compLog('fetch response', { ok: res.ok, status: res.status, url: resolvedUrl });
        if (!res.ok) return null;
        return res.text();
      })
      .then(function (text) {
        if (text == null) {
          compLog('fetch: no text (aborted or !ok); skip inject');
          return;
        }

        compLog('fetch: HTML length=', text.length);

        text = text.replaceAll('variant-selects', 'div').replaceAll('variant-radios', 'div');
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fragment = findComplementaryFragment(doc, container.id);

        if (!fragment) {
          compLog('WARN: findComplementaryFragment returned null; container.id=', container.id);
        } else {
          compLog('fragment found; innerHTML length=', fragment.innerHTML.trim().length);
        }

        if (fragment && fragment.innerHTML.trim().length > 0) {
          container.innerHTML = fragment.innerHTML;
          compLog('injected innerHTML into container id=', container.id);
          if (window.sharedFunctions && window.sharedFunctions.checkNeedToConvertCurrency()) {
            whenJQuerySlickReady(function ($) {
              Currency.convertAll(
                window.shop_currency,
                $('#currencies .active').attr('data-currency'),
                'span.money',
                'money_format',
              );
            });
          }
        } else {
          compLog('WARN: no fragment or empty innerHTML — nothing injected');
        }

        var hasProduct = container.querySelector('.product');
        compLog('after inject, .product count=', hasProduct ? container.querySelectorAll('.product').length : 0);

        if (!hasProduct && !isRetry) {
          try {
            var u = new URL(resolvedUrl, window.location.href);
            var cur = u.searchParams.get('intent') || 'related';
            u.searchParams.set('intent', cur === 'complementary' ? 'related' : 'complementary');
            compLog('retry fetch with swapped intent ->', u.toString());
            fetchProducts(container, u.toString(), true);
            return;
          } catch (e) {
            compLog('intent swap failed', e);
          }
        }

        var isCartDrawer = container.closest('.cart-drawer-complementary');
        if (isCartDrawer) {
          compLog('inside cart-drawer-complementary; skipping Slick init');
        } else {
          whenJQuerySlickReady(function ($) {
            initializeSlider(container, $);
          });
        }
      })
      .catch(function (err) {
        compLog('fetch ERROR', err);
      });
  }

  function processInlineQueue() {
    var q = window.__BOOM_COMP_REC_QUEUE;
    var len = q ? q.length : 0;
    if (!len) {
      return;
    }
    compLog('processInlineQueue: draining', len, 'item(s)', JSON.parse(JSON.stringify(q)));

    var remaining = [];
    for (var i = 0; i < q.length; i++) {
      var item = q[i];
      if (!item || !item.url || !item.id) {
        compLog('processInlineQueue: skip invalid item', item);
        continue;
      }
      var el = document.getElementById(item.id);
      if (!el) {
        compLog('processInlineQueue: element not in DOM yet, id=', item.id);
        remaining.push(item);
        continue;
      }
      if (el.getAttribute('data-comp-initialized') === 'true') {
        compLog('processInlineQueue: already initialized id=', item.id);
        continue;
      }
      el.setAttribute('data-comp-initialized', 'true');
      compLog('processInlineQueue: calling fetchProducts for id=', item.id);
      fetchProducts(el, item.url, false);
    }
    window.__BOOM_COMP_REC_QUEUE = remaining;
    if (remaining.length) {
      compLog('processInlineQueue: left in queue for later', remaining.length);
    }
  }

  function initComplementaryContainer(container) {
    if (!container || container.nodeType !== 1) return;
    if (container.getAttribute('data-comp-initialized') === 'true') return;
    container.setAttribute('data-comp-initialized', 'true');

    var url = container.getAttribute('data-url') || (container.dataset && container.dataset.url) || '';
    url = typeof url === 'string' ? url.trim() : '';
    compLog('initComplementaryContainer (attribute path)', {
      id: container.id,
      urlLength: url.length,
      urlPreview: url.slice(0, 120),
    });

    if (url) {
      fetchProducts(container, url, false);
    } else {
      var isCartDrawer = container.closest('.cart-drawer-complementary');
      if (isCartDrawer) {
        compLog('initComplementaryContainer: no data-url; inside cart drawer, skipping Slick');
      } else {
        compLog('initComplementaryContainer: no data-url; slider-only path');
        whenJQuerySlickReady(function ($) {
          initializeSlider(container, $);
        });
      }
    }
  }

  function scanNode(node) {
    if (!node || node.nodeType !== 1) return;
    if (typeof node.matches === 'function' && node.matches(SELECTOR)) {
      initComplementaryContainer(node);
    }
    if (node.querySelectorAll) {
      var list = node.querySelectorAll(SELECTOR);
      if (list.length) {
        compLog('scanNode: found', list.length, SELECTOR, 'under', node.nodeName, node.id || '');
      }
      for (var i = 0; i < list.length; i++) {
        initComplementaryContainer(list[i]);
      }
    }
  }

  function boot() {
    bootCount += 1;
    compLog('boot #' + bootCount, { readyState: document.readyState });

    var qLen = window.__BOOM_COMP_REC_QUEUE ? window.__BOOM_COMP_REC_QUEUE.length : 0;
    var nodeLen = document.body ? document.body.querySelectorAll(SELECTOR).length : 0;
    compLog('boot snapshot', { queueLength: qLen, complementaryNodes: nodeLen });

    if (
      document.readyState === 'complete' &&
      !warnedNoComplementaryMarkup &&
      qLen === 0 &&
      nodeLen === 0
    ) {
      warnedNoComplementaryMarkup = true;
      compLog(
        'WARN: after load, no Liquid queue items and no',
        SELECTOR,
        'in DOM. The main-product complementary block is probably missing, disabled, skipped (manual list empty / show off), or this page is not using a template that renders complementary-products-main.',
      );
    }

    processInlineQueue();

    if (document.body) {
      scanNode(document.body);
    }
    scanNode(document.documentElement);
  }

  document.addEventListener('DOMContentLoaded', function () {
    compLog('DOMContentLoaded fired');
    boot();
  });

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    compLog('readyState already interactive/complete; boot now');
    boot();
  }
  setTimeout(function () {
    compLog('setTimeout(0) boot');
    boot();
  }, 0);

  window.addEventListener('load', function () {
    compLog('window load boot');
    boot();
  });

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function (mutations) {
      processInlineQueue();
      for (var m = 0; m < mutations.length; m++) {
        var added = mutations[m].addedNodes;
        for (var i = 0; i < added.length; i++) {
          scanNode(added[i]);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  compLog('listeners registered; call __boomCompDumpState() anytime');
})();
